import {IS_DEV} from 'util/app-info';

export default {
  serverURL: IS_DEV ? 'http://localhost:3000' : '',
  connectionTimeout: 60000,
  googleMapApiKey: 'AIzaSyBhl2hHeaP729or5l84cQT8UAvuTk0Nwn8',
  termsUrl: 'https://d353a277opzr0y.cloudfront.net/legal/gc_terms.htm',
  privacyUrl: 'https://d353a277opzr0y.cloudfront.net/legal/gc_privacy.htm',
};
